import { useSyncExternalStore } from "react";

// ⌘K paletinin açık/kapalı durumu: üst bar ve klavye kısayolu aynı depoyu kullanır.
let paletteOpen = false;
const subs = new Set<() => void>();

export const setPaletteOpen = (v: boolean) => {
  paletteOpen = v;
  subs.forEach((s) => s());
};
export const togglePalette = () => setPaletteOpen(!paletteOpen);
export const openCommandPalette = () => setPaletteOpen(true);

export const usePaletteOpen = () =>
  useSyncExternalStore(
    (l) => {
      subs.add(l);
      return () => subs.delete(l);
    },
    () => paletteOpen
  );
